import api from "./api"

export default {
  install(Vue) {
    Vue.prototype.$zaiq = () => {
      return api.zaiq()
    }
    Vue.prototype.$osapm = () => {
      return api.osapm()
    }
  }
};